import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "jClassName",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_InputText, {
            id: "jClassName",
            class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.dataset.jClassName.$invalid && _ctx.v$.dataset.jClassName.$dirty
                        }],
            type: "text",
            style: _ctx.javaDatasetDescriptor.style.maxWidth,
            modelValue: _ctx.v$.dataset.jClassName.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.jClassName.$model = $event)),
            modelModifiers: { trim: true },
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.jClassName.$touch())),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
          }, null, 8, ["style", "modelValue", "class"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.lovsManagement.javaClassName')) + " * ", 1)
        ]),
        _createVNode(_component_KnValidationMessages, {
          class: "p-mt-1",
          vComp: _ctx.v$.dataset.jClassName,
          additionalTranslateParams: { fieldName: _ctx.$t('managers.lovsManagement.javaClassName') }
        }, null, 8, ["vComp", "additionalTranslateParams"])
      ])
    ]),
    _: 1
  }))
}